<div class="pick-and-pack-table__wrapper">
  <div
    class="overlay"
    lumAppLoader
    [loading]="loading"
    [classes]="'loading blur'"
  ></div>
  <form [formGroup]="form">
    <div
      *ngIf="'utah_FR-617_show_bom_notes_on_assembly_order_items' | featureFlag"
      class="d-flex justify-content-end"
    >
      <button
        type="button"
        class="lum-button lum-button--link lum-button--small"
        (click)="handleToggleNotesClick($event)"
      >
        {{ isShowingNotes ? 'Hide Notes' : 'Show Notes' }}
      </button>
    </div>
    <table class="lum-table lum-table--classic striped">
      <tr class="table__head-row">
        <th>Product Name</th>
        <th>SKU</th>
        <th>Predicted</th>
        <th>Actual</th>
        <th>Warehouse</th>
        <th>Location</th>
        <th *ngIf="hasLotTracking" class="w-auto">Lot</th>
        <th
          *ngIf="
            ('utah_FR-617_show_bom_notes_on_assembly_order_items' | featureFlag) &&
            isShowingNotes
          "
        >
          Notes
        </th>
      </tr>
      <ng-container>
        <tbody formArrayName="rows">
          <tr
            *ngFor="
              let row of rows?.controls;
              trackBy: trackByControlValue;
              let i = index
            "
            [formGroupName]="i"
            [ngClass]="{ 'table__row--splitted': row?.value.tempId }"
          >
            <td>
              {{ row?.value?.productName }}
            </td>
            <td>
              {{ row?.value?.internalSku }}
            </td>
            <td>
              {{ row?.value?.plannedQty | decimalPlaces }}
              {{ row?.value?.plannedUomName || '' }}
            </td>
            <td>
              <div>
                <input
                  lumDecimalLimit
                  formControlName="actualQty"
                  class="lum-input"
                  type="number"
                  matInput
                  (input)="onInputEvent($event, i)"
                  [ngClass]="{
                    error: row.get('actualQty')?.invalid,
                  }"
                />
              </div>
              <mat-error
                *ngIf="row.get('actualQty') && row.get('actualQty')?.invalid"
              >
                {{ row.get('actualQty') | validateField }}
              </mat-error>
            </td>
            <td>
              <div class="flex">
                <mat-select
                  class="lum-select"
                  formControlName="warehouseId"
                  (selectionChange)="onSelectWarehouseEvent($event, i)"
                  [ngClass]="{
                    error: row.get('warehouseId')?.invalid,
                  }"
                >
                  <mat-option
                    *ngFor="let warehouse of warehouses || []; trackBy: trackById"
                    [value]="warehouse.id"
                  >
                    {{ warehouse.locationName }}
                  </mat-option>
                </mat-select>
              </div>
              <mat-error
                *ngIf="row.get('warehouseId') && row.get('warehouseId')?.invalid"
              >
                {{ row.get('warehouseId') | validateField }}
              </mat-error>
            </td>
            <td>
              <div class="flex">
                <mat-select
                  class="lum-select"
                  formControlName="locationId"
                  (selectionChange)="onSelectLocationEvent($event, i)"
                  [ngClass]="{
                    error: row.get('locationId')?.invalid,
                  }"
                >
                  <mat-option
                    *ngFor="
                      let location of locations[row.get('warehouseId')?.value] || []
                    "
                    [value]="location.id"
                  >
                    {{ location.location_name }}
                  </mat-option>
                </mat-select>
              </div>
              <mat-error
                *ngIf="row.get('locationId') && row.get('locationId')?.invalid"
              >
                {{ row.get('locationId') | validateField }}
              </mat-error>
            </td>
            <td *ngIf="hasLotTracking">
              <div class="flex">
                <input
                  *ngIf="row.get('lotTracking')?.value || false"
                  matInput
                  [matAutocomplete]="auto"
                  class="lum-input"
                  formControlName="lotId"
                  placeholder="Type to search..."
                  #autocompleteInput
                  (input)="onInputLotChange(i, autocompleteInput.value)"
                />
                <mat-autocomplete
                  #auto="matAutocomplete"
                  [displayWith]="displayFnLot"
                  (optionSelected)="onSelectLotEvent($event, i)"
                >
                  <mat-option
                    *ngFor="
                      let lot of lots?.[row?.value?.rfqId]?.[
                        row?.value?.locationId
                      ] || []
                    "
                    [value]="lot?.id"
                  >
                    {{ lot?.lotNumber }}
                  </mat-option>
                  <mat-divider></mat-divider>
                  <mat-option
                    [disabled]="true"
                    *ngIf="
                      lots?.[row?.value?.rfqId]?.[row?.value?.locationId]
                        ?.length === 0
                    "
                    >No lot number found</mat-option
                  >
                  <button
                    mat-button
                    class="create-new-lot"
                    (click)="onCreateNewLot(i)"
                  >
                    Create a New Lot
                  </button>
                </mat-autocomplete>
              </div>
              <mat-error *ngIf="row.get('lotId') && row.get('lotId')?.invalid">
                {{ row.get('lotId') | validateField }}
              </mat-error>
            </td>
            <td
              *ngIf="
                ('utah_FR-617_show_bom_notes_on_assembly_order_items'
                  | featureFlag) && isShowingNotes
              "
            >
              {{ items[i]?.note }}
            </td>
          </tr>
        </tbody>
      </ng-container>
    </table>
  </form>
</div>
